import TaskParamsModal from './TaskParamsModal.js'

export default function Modals() {
  return (
    <>
      <TaskParamsModal />
    </>
  )
}
